import { useQuery } from "@tanstack/react-query";
import {
  fetchFlavorComposition,
  type CompositionResponse,
} from "@/services/composition_api";

export const flavorCompositionKeys = {
  all: ["flavorComposition"] as const,
  byFlavor: (id: string) => ["flavorComposition", id] as const,
};

export function useFlavorComposition(flavorId: string | null) {
  return useQuery<CompositionResponse>({
    queryKey:
      flavorId !== null
        ? flavorCompositionKeys.byFlavor(flavorId)
        : flavorCompositionKeys.byFlavor("__none__"),
    queryFn: ({ signal }) => fetchFlavorComposition(flavorId!, signal),
    enabled: flavorId !== null,
    staleTime: 60_000,
  });
}
